import EmptyState from '@/component/Empty';
import Translate from '@/component/Translate';
import { useTexts } from '@/feature/lang';
import Button from '@mui/material/Button';
import { Table } from '@tanstack/react-table';
import { BodyCell } from '../../components/BodyCell';
import { TableRow } from '../../components/TableRow';
import { useDataProvider } from '../../DataProviderContext';

function getIsColumnFilterActive(table?: Table<any>) {
  return table?.getState() && table.getState().columnFilters.length > 0;
}

export const Empty = () => {
  const texts = useTexts().component.table;
  const { table } = useDataProvider();
  const isColumnFilterActive = getIsColumnFilterActive(table);
  const clearColumnFilters = () => table?.setColumnFilters([]);

  if (!table) {
    return null;
  }

  return (
    <TableRow>
      <BodyCell
        colSpan={table.getVisibleFlatColumns().length}
        sx={{ border: 0 }}
      >
        {isColumnFilterActive ? (
          <EmptyState
            text={texts.emptyWithFilters}
            actions={
              <Button
                color="grey"
                variant="contained"
                onClick={clearColumnFilters}
              >
                <Translate text={texts.actions.clearFilters} />
              </Button>
            }
          />
        ) : (
          <EmptyState />
        )}
      </BodyCell>
    </TableRow>
  );
};
